import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const TESTIMONIALS = [
  {
    id: 1,
    name: "Carlos Vega",
    location: "San Juan, Puerto Rico.",
    stars: 4,
    text: "Llevaron mi carro desde Puerto Rico a Estados Unidos. Recibí un trato excepcional, y mi carro llegó en perfecto estado. ¡Los recomiendo sin dudarlo! 🚗🤝",
    photo: "/images/testimonial-carlos.jpg",
  },
  {
    id: 2,
    name: "Gabriela Brown",
    location: "Mayagüez, Puerto Rico.",
    stars: 5,
    text: "Definitivamente superaron mis expectativas. Fueron super efectivos, y cumplieron con todos los requisitos para transportar mi carro ¡Mil gracias! 🚗🤝",
    photo: "/images/testimonial-gabriela.jpg",
  },
  {
    id: 3,
    name: "Ana Vega",
    location: "Orlando, Florida.",
    stars: 5,
    text: "Me entregaron mi auto rápidamente, muy bien cuidado y con todo en regla. Una gran atención y asesoría.",
    photo: "/images/testimonial-3.jpg",
  },
];

const StarRating = ({ count }) => (
  <div className="d-flex gap-1">
    {Array.from({ length: 5 }).map((_, i) => (
      <i
        key={i}
        className={`bi ${i < count ? "bi-star-fill" : "bi-star-half"} testimonial-star`}
      ></i>
    ))}
  </div>
);

const TestimonialCard = ({ testimonial }) => (
  <div className="testimonial-card">
    {/* Header: avatar + name/location row + stars row */}
    <div className="d-flex align-items-center gap-3 mb-3">
      <img
        src={testimonial.photo}
        alt={testimonial.name}
        className="testimonial-avatar-img"
      />
      <div>
        <p className="mb-0 testimonial-name">
          <strong>{testimonial.name}</strong>
          <span className="testimonial-location-separator"> | </span>
          <span className="testimonial-location">{testimonial.location}</span>
        </p>
        <StarRating count={testimonial.stars} />
      </div>
    </div>
    <p className="testimonial-text">{testimonial.text}</p>
  </div>
);

const Testimonios = () => (
  <div className="py-5">
    <Container>
      <p className="text-primary mb-0" style={{ fontSize: "0.9em" }}>
        Escucha nuestros
      </p>
      <h2 className="beba-font mb-5 testimonios-title">Testimonios</h2>
      <Row className="g-4">
        {TESTIMONIALS.map((t) => (
          <Col md={4} key={t.id}>
            <TestimonialCard testimonial={t} />
          </Col>
        ))}
      </Row>
    </Container>
  </div>
);

export default Testimonios;
